<template>
  <div
    class="equipmentWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="leftMenuBox">
      <TreeMenu @getTreeActive="getTreeActive" />
    </div>
    <div class="contentBox">
      <div class="middleBox">
        <div class="energyCharts commonWrap">
          <div class="commonTitle">
            <div></div>
            <el-button
              type="primary"
              size="small"
              plain
              icon="el-icon-download"
              style="margin-right: 20px"
              @click="exportExcel"
              v-if="judgeAuthority('nengyuan:equipmentConsume:export')"
              >EXCEL
            </el-button>
          </div>
          <div class="commonContentBox">
            <PublicEcharts
              id="'myCharts'"
              :chartsData="chartsData"
              :type="'lightLine'"
            />
          </div>
        </div>
        <div class="energyTable commonWrap">
          <div style="width: 95%; height: 90%; margin: 20px auto 10px">
            <el-table
              :data="equipmentList"
              height="90%"
              stripe
              style="width: 100%"
              size="mini"
              :header-cell-style="{
                'font-weight': 'bold',
                color: '#333',
                'background-color': '#F7F7F7',
              }"
            >
              <el-table-column
                v-for="(v, i) in tableHead"
                :key="i"
                :prop="v.prop"
                :label="v.label"
                align="center"
              ></el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 30]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
              style="text-align: right; margin-top: 10px"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <div class="showData">
          <ul>
            <li
              v-for="(v, i) in menuList"
              :key="i"
              :style="{ background: bgColor[i] }"
            >
              <div class="textBox">
                <p>{{ v.title }}</p>
                <h5 v-if="v.num != null">
                  {{ v.num | numberToCurrency }}
                </h5>
                <span>{{ chartsData.unit }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="chartsTop commonWrap">
          <div class="commonTitle">
            <h4><span>1</span>能耗排名</h4>
            <div style="margin-right: 20px">
              <el-button type="primary" size="small" style="margin-right: 20px"
                >TOP10
              </el-button>
            </div>
          </div>
          <div class="commonContentBox">
            <PublicEcharts
              :id="'chartsTop'"
              :chartsData="tableList"
              :type="'themeTransverseBar'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import TreeMenu from "@/components/nengyuanguanli/EquipmentConsume/TreeMenu";
import PublicEcharts from "@/components/PublicEcharts.vue";
import {
  dateFtt,
  judgeAuthority,
  matchingECNameUnit,
  handleNumDecimal,
} from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";

export default {
  components: {
    TreeMenu,
    PublicEcharts,
  },
  data() {
    return {
      tableHead: [],
      equipmentList: [],
      chartsData: {
        name: "",
        unit: "",
        xData: [],
        dataArr: [],
      },
      bgColor: ["#3090F6", "#F7C126", "#28CCCB"],
      menuList: [],
      tableList: {
        name: "",
        unit: "",
        xData: [],
        yData: [],
      },
      treeData: {},
      currentPage: 1,
      page: {
        total: null,
        size: 5,
      },
    };
  },
  methods: {
    judgeAuthority,

    getTreeActive(data) {
      this.treeData = data;
      this.handleTableHead();
      this.getEquipmentList();
      this.getBarData();
      this.getLineData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getEquipmentList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getEquipmentList();
    },
    async getEquipmentList() {
      this.equipmentList = [];
      let res = await api.equipmentEnergyGetList({
        assetId: this.treeData.assetId,
        deviceTypes: this.treeData.deviceType,
        energyType: this.treeData.activeType,
        dateType: this.treeData.type,
        dateRange: this.treeData.date,
        pageSize: this.page.size,
        page: this.currentPage - 1,
        label: this.treeData.label,
        tree: this.treeData.allTreeData[0],
      });
      if (res && res.data.code == 200) {
        this.equipmentList = Array.from(res.data.data.data).map((v) => ({
          name: v.name,
          dayValue: handleNumDecimal(v.dayValue),
          monthValue: handleNumDecimal(v.monthValue),
          yearValue: handleNumDecimal(v.yearValue),
          totalValue: v.totalValue
            ? handleNumDecimal(v.totalValue / 10000)
            : "",
        }));
        this.page.total = res.data.data.totalElements;
      }
    },
    handleTableHead() {
      this.tableHead = [
        { label: "资产/设备", prop: "name" },
        {
          label: "日用电量/kw·h",
          prop: "dayValue",
        },
        {
          label: `月${matchingECNameUnit(
            this.treeData.activeType,
            "name",
          )}/${matchingECNameUnit(this.treeData.activeType, "unit")}`,
          prop: "monthValue",
        },
        {
          label: `年${matchingECNameUnit(
            this.treeData.activeType,
            "name",
          )}/${matchingECNameUnit(this.treeData.activeType, "unit")}`,
          prop: "yearValue",
        },
        {
          label: `累计${matchingECNameUnit(
            this.treeData.activeType,
            "name",
          )}/万${matchingECNameUnit(this.treeData.activeType, "unit")}`,
          prop: "totalValue",
        },
      ];
      if (this.treeData.activeType !== "power") {
        this.tableHead = this.tableHead.filter((v) => {
          return v.prop !== "dayValue";
        });
      }

      if (!this.treeData.name.children?.length) {
        this.tableHead = this.tableHead.filter((v) => {
          return v.prop !== "totalValue";
        });
      }
    },
    async getBarData() {
      this.tableList.xData = [];
      this.tableList.yData = [];
      this.tableList.name = matchingECNameUnit(
        this.treeData.activeType,
        "name",
      );
      this.tableList.unit = matchingECNameUnit(
        this.treeData.activeType,
        "unit",
      );
      let res = await api.equipmentEnergyBarDataList({
        assetId: this.treeData.assetId,
        deviceTypes: this.treeData.deviceType,
        energyType: this.treeData.activeType,
        dateType: this.treeData.type,
        dateRange: this.treeData.date,
        label: this.treeData.label,
        tree: this.treeData.allTreeData[0],
      });

      if (res && res.data.code == 200) {
        res.data.data.slice(0, 10).map((v, i) => {
          this.tableList.xData.push(v.sumAddition);
          this.tableList.yData.push(v.entityName);
        });
      }
    },
    async getLineData() {
      let title = matchingECNameUnit(this.treeData.activeType, "title");
      this.menuList = [
        { title: `平均${title}`, num: null, key: "avg" },
        { title: `最高${title}`, num: null, key: "max" },
        { title: `最低${title}`, num: null, key: "min" },
      ];
      this.chartsData.xData = [];
      this.chartsData.name = matchingECNameUnit(
        this.treeData.activeType,
        "name",
      );
      this.chartsData.unit = matchingECNameUnit(
        this.treeData.activeType,
        "unit",
      );
      let res = await api.equipmentEnergyNewCharts({
        assetId: this.treeData.assetId,
        type: this.treeData.type,
        date: this.treeData.date,
        energyType: this.treeData.activeType,
      });
      if (res && res.data.code == 200) {
        this.chartsData.dataArr = [{ name: this.chartsData.name, data: [] }];
        this.menuList.map((v) => {
          v.num = res.data.data[v.key]
            ? handleNumDecimal(res.data.data[v.key])
            : 0;
        });
        res.data.data.chartParamsList.map((v) => {
          this.chartsData.xData.push(
            this.treeData.type == "DAY"
              ? dateFtt("dd日hh:mm", new Date(v.time))
              : this.treeData.type == "YEAR"
              ? dateFtt("yyyy-MM", new Date(v.time))
              : this.treeData.type == "UNLIMITED"
              ? dateFtt("yyyy年", new Date(v.time))
              : dateFtt("yyyy-MM-dd", new Date(v.time)),
          );
          this.chartsData.dataArr[0].data.push(v.assets[0].data);
        });
      }
    },

    exportExcel() {
      let th = ["时间"];
      th.push(
        `${this.treeData.name.name}(${matchingECNameUnit(
          this.treeData.activeType,
          "unit",
        )})`,
      );
      // 内容区
      let content = [];
      for (let i = 0; i < this.chartsData.xData.length; i++) {
        let row = [];
        row.push(this.chartsData.dataArr[0].data[i]);
        row.unshift(this.chartsData.xData[i]);
        content.push(row);
      }
      exportFile.xlsxFile(
        XLSX,
        `${this.treeData.name.name}-${
          this.treeData.date ? this.treeData.date : "总计"
        }`,
        {
          excel: [th, ...content],
        },
      );
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.equipmentWrap {
  @include setFlexBetween;

  .leftMenuBox {
    @include setMenuWH;
  }
  .contentBox {
    @include setCenterWH;
    @include setFlexBetween;
    .middleBox {
      width: calc(60% - 12px);
      height: 100%;
      @include setFlexColumn;
      justify-content: space-between;
      .energyCharts {
        height: calc(57% - 12px);
        width: 100%;
      }
      .energyTable {
        height: 43%;
        width: 100%;
      }
    }
    .rightBox {
      width: 40%;
      height: 100%;
      @include setFlexColumn;
      justify-content: space-between;
      .showData {
        width: 100%;
        height: 13%;
        ul {
          width: 100%;
          height: 95%;
          @include setFlexBetween;
          li {
            width: 32%;
            height: 100%;
            border-radius: 10px;
            color: #fff;

            .textBox {
              margin: 12% 0 0 25px;

              p {
                font-size: 14px;
                margin-bottom: 5px;
              }

              h5 {
                font-size: 20px;
              }
            }
          }
        }
      }
      .chartsTop {
        width: 97%;
        height: calc(87% - 12px);
      }
    }
  }
}
</style>
